import React from 'react';
import { useIntl } from 'react-intl';
import CategoryCard, { Category } from './components/CategoryCard';
import RedirectionModal from './../../common/components/modal/RedirectionModal';
import { useRedirectionModal } from './../../common/components/modal/hooks/useRedirectionModal';

const AccesInternet = (): JSX.Element => {
  const intl = useIntl();
  const { isOpen, closeModal, confirmRedirection, handleContinue, pendingUrl, countdown } = useRedirectionModal();
  
  const categories: Category[] = [
    {
      id: 1,
      icon: 'fa-solid fa-wifi',
      title: intl.formatMessage({id: 'MARKETPLACE.INTERNET.FIBER_SHARED.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.INTERNET.FIBER_SHARED.DESC'}),
      iconBg: 'primary',
      urlCommande: 'https://commande.celeste.fr/v8?e-celeste=1',
      urlEnSavoirPlus: 'https://www.celeste.fr/fibre-optique-et-acces-internet-entreprise/ftth-entreprise-fibre-first/',
      isActive: true,
    },
    {
      id: 2,
      icon: 'fa-solid fa-network-wired',
      title: intl.formatMessage({id: 'MARKETPLACE.INTERNET.FIBER_DEDICATED.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.INTERNET.FIBER_DEDICATED.DESC'}),
      iconBg: 'primary',
      urlCommande: 'https://commande.celeste.fr/v8?e-celeste=1',
      urlEnSavoirPlus: 'https://www.celeste.fr/fibre-optique-et-acces-internet-entreprise/fibre-optique-dediee-entreprise/',
      isActive: true,
    },
    {
      id: 3,
      icon: 'fa-solid fa-shield-halved',
      title: intl.formatMessage({id: 'MARKETPLACE.INTERNET.SECURE.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.INTERNET.SECURE.DESC'}),
      iconBg: 'primary',
      urlCommande: 'https://e-celeste.fr/categorie-produit/connexion/compte-internet-securise',
      urlEnSavoirPlus: 'https://www.celeste.fr/compte-internet-securise/',
      isActive: true,
    },
    {
      id: 4,
      icon: 'fa-solid fa-tower-cell',
      title: intl.formatMessage({id: 'MARKETPLACE.INTERNET.4G.TITLE'}),
      description: intl.formatMessage({id: 'MARKETPLACE.INTERNET.4G.DESC'}),
      iconBg: 'primary',
      urlCommande: 'https://commande.celeste.fr/mobile/box/forfaits?e-celeste=1',
      urlEnSavoirPlus: 'https://www.celeste.fr/fibre-optique-et-acces-internet-entreprise/connexion-4g-5g-entreprise/',
      isActive: false,
    },
  ];

  const handleOrder = (categoryTitle: string) => {
    const category = categories.find(cat => cat.title === categoryTitle);
    if (category?.urlCommande) {
      confirmRedirection(category.urlCommande);
    }
  };

  const handleLearnMore = (categoryTitle: string) => {
    const category = categories.find(cat => cat.title === categoryTitle);
    if (category?.urlEnSavoirPlus) {
      confirmRedirection(category.urlEnSavoirPlus);
    }
  };

  return (
    <>
      <RedirectionModal
        show={isOpen}
        onCancel={closeModal}
        onContinue={handleContinue}
        url={pendingUrl || ''}
        countdown={countdown}
      />

      <div className="row g-4">
        {categories.map((category) => (
          <CategoryCard
            key={category.id}
            category={category}
            onOrder={handleOrder}
            onLearnMore={handleLearnMore}
          />
        ))}
      </div>
    </>
  );
};

export default AccesInternet;
